import { ProductVariation } from '../types';

function hasSpotFinishing(variations: ProductVariation[]): boolean {
  return variations.some(
    (variation) => variation.spotfinishingtype !== undefined && variation.spotfinishingtype !== 'none',
  );
}

export default hasSpotFinishing;
